import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo Api回傳格式
 */
export interface FidoAuthenticateResp extends GeneralResp {}

/**
 * @todo FIDO 驗證輪詢
 */
const FidoAuthenticate = (): Promise<FidoAuthenticateResp> => {
    const url = RouteUrlList.API_FidoAuthenticate.path;
    const data = {};
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.false,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<FidoAuthenticateResp>) => {
        return res.data;
    });
};

export default FidoAuthenticate;
